<template lang="html">
  <div class="projectBasicContainer">
    <h1>檢視管理員</h1>
    <div class="tableContainer">
      <div class="fourColumn">
        <div class="title">姓名</div>
        <div class="text">{{ adminInfo.name }}</div>
        <div class="title">職位</div>
        <div class="text">
          <Select v-model="adminInfo.positionId" size="large" disabled placeholder="請選擇">
            <Option v-for="item in positionOptions" :value="item.id" :key="item.id">{{ item.positionName }}</Option>
          </Select>
        </div>
        <div class="title">帳號</div>
        <div class="text">{{ adminInfo.account }}</div>
        <div class="title">密碼</div>
        <div class="text">{{ '****' }}</div>
      </div>
    </div>
    <div class="btnContainer">
      <Button type="info" @click="edit">編輯</Button>
      <Button type="error" @click="archive">封存</Button>
      <router-link to="/admin" tag="Button">取消</router-link>
    </div>
  </div>
</template>
<script>
import API from "../asset/js/API"

import jsCookie from 'js-cookie'
export default {
  created () {
    // webServer.defaults.headers.common['x-access-token'] = jsCookie.get('token')
    this.setData()
    this.getPositionList()
  },
  data () {
    return {
      adminInfo: {
        id: null,
        name: null,
        position: null,
        positionId: null,
        account: null,
        password: null
      },
      positionOptions: [],
    }
  },
  methods: {
    getPositionList() {
      API.get(`/manager/position`)
      .then(res => {
        this.positionOptions = res.result.list
        this.adminInfo.positionId = this.findPositionId()
      })
      .catch(err => {
        console.error('職位列表',err)
      })
    },
    setData() {
      this.adminInfo = JSON.parse(JSON.stringify(this.$route.params))
    },
    findPositionId() {
      const CurrentPosition = this.positionOptions.find( item => {
        return item.positionName ===  this.adminInfo.position
      })
      return CurrentPosition.id
    },
    edit() {
      this.$router.push({ name: "EditAdmin", params: { ...this.$data } });
    },
    archive() {
      API.put(`/manager/${this.adminInfo.id}/seal`)
      .then(res => {
        this.$Message.info(res.result)
      })
      .catch(err => {
        console.error('新增管理員',err)
      })

    }
  }
}

</script>
<style lang="scss" scoped>
@import "@/scss/base.scss";
@import "@/scss/components.scss";
</style>



// WEBPACK FOOTER //
// src/components/AdminInfo.vue